import {CommonModule, NgOptimizedImage, NgStyle} from '@angular/common';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {ProfileService} from './profile.service';
import {Storage} from './storage.service';
import {RadarService} from './radar.service';
import {Cache} from './cache.service';
import {ProfileIconDirective} from './profile-icon.directive';
import {IonicModule, IonRange} from '@ionic/angular';
import {PipesModule} from './pipes.module';
import {RaainMapComponent} from './raain-map/raain-map.component';
import {RaainCompareComponent} from './raain-compare/raain-compare.component';
import {RaainConfigurationComponent} from './raain-configuration/raain-configuration.component';
import {RaainDateFocusComponent} from './raain-date-focus/raain-date-focus.component';
import {RaainDateDynamicComponent} from './raain-date-dynamic/raain-date-dynamic.component';
import {RaainSpeedComponent} from './raain-speed/raain-speed.component';
import {RaainCompareStackComponent} from './raain-compare-stack/raain-compare-stack.component';
import {RaainGlobeComponent} from './raain-globe/raain-globe.component';
import {RaainDetailsComponent} from './raain-details/raain-details.component';
import {CumulativeSelectorComponent} from './cumulative-selector/cumulative-selector.component';

@NgModule({
    declarations: [
        RaainMapComponent,
        RaainCompareComponent,
        RaainCompareStackComponent,
        RaainDateFocusComponent,
        RaainDateDynamicComponent,
        RaainConfigurationComponent,
        RaainSpeedComponent,
        RaainGlobeComponent,
        ProfileIconDirective,
        RaainDetailsComponent,
        CumulativeSelectorComponent,
    ],
    imports: [CommonModule, FormsModule, IonicModule, NgOptimizedImage, PipesModule],
    providers: [Storage, RadarService, ProfileService, Cache, IonRange],
    exports: [
        CommonModule,
        NgStyle,
        PipesModule,

        RaainMapComponent,
        RaainCompareComponent,
        RaainCompareStackComponent,
        RaainDateFocusComponent,
        RaainDateDynamicComponent,
        RaainConfigurationComponent,
        RaainSpeedComponent,
        RaainGlobeComponent,
        ProfileIconDirective,
        RaainDetailsComponent,
        CumulativeSelectorComponent,
    ],
})
export class SharedModule {
    constructor(@Optional() @SkipSelf() parentModule?: SharedModule) {
        if (parentModule) {
            // throw new Error(
            console.warn('SharedModule is already loaded. Import it in the AppModule only');
        }
    }
}
